// AutoClaim is intentionally unavailable in Trade while its product direction
// is being evaluated. Keep the implementation behind this flag so it can be
// restored without rebuilding the feature.
export const TRADE_AUTO_CLAIM_ENABLED = false;
